import React, { useEffect } from "react";
import { Label, Badge } from "reactstrap";
import './EvaluationReview.css';

const EvaluationReview = ({
    account,
    session,
    factor,
    summaryAnswer,
    currentStep,
    currentSubPage,
    maxSubPage,
    setCurrentStep,
    setCurrentSubPage,
    setMaxSubPage,
    setStepInComplete,
    setSubPageInComplete,
    setValidationMessage
}) => {

    const factors = factor.filter(a => a.grading);

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
    };

    useEffect(() => {
        setMaxSubPage(0);
        setStepInComplete(false);
        setSubPageInComplete(false);
    }, [setMaxSubPage]);

    const getGradeForFactor = (factorId) => {
        const found = summaryAnswer.factors.find(ans => ans.key === factorId);
        return found?.data?.grade ?? null;
    };

    return (
        <div className="evaluation-review">
            <div className="label-row">
                <div>
                    <Label className="review-label-title">AGENT NAME:</Label>
                    <Label>{account?.Name}</Label>
                </div>
                <div>
                    <Label className="review-label-title">DATE:</Label>
                    <Label>{formatDate(session?.SessionDate)?.toUpperCase()}</Label>
                </div>
            </div>

            <div className="label-row">
                <div className="d-flex">
                    <Label className="review-label-title">CLIENT NAME:</Label>
                    <Label>
                        {summaryAnswer?.clients
                            ? summaryAnswer.clients.map(c => c.name).join(', ')
                            : ''}
                    </Label>
                </div>
            </div>

            <div className="review-body">
                {factors.map(f => {
                    const selectedGrade = getGradeForFactor(f.factor_id);

                    return (
                        <div key={f.factor_id} className="mb-2">
                            <div className="rating-header d-flex align-items-center justify-content-between">
                                <span className="category-label">{f.factor}</span>
                                <div className="rating-scale d-flex align-items-center my-2">
                                    <span className="progress-badge me-2">{f.weight}%</span>
                                    {f.grading.map(({ value }) => (
                                        <button
                                            key={value}
                                            type="button"
                                            className={`rating-btn label-semibold ${value === selectedGrade ? 'selected' : ''}`}
                                            disabled
                                        >
                                            {value}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
                <div className="final-rating-row">
                    <span className="final-rating-label">Final Rating:</span>
                    <div className="d-flex">
                        {summaryAnswer?.final_grade <= 2.5 &&
                            < Badge color="danger" pill className="badge me-2">
                                FAILED
                            </Badge>
                        }
                        <span className="final-rating-value">
                            {summaryAnswer?.final_grade?.toFixed(2)}
                        </span>
                    </div>
                </div>


                <div className="factor-text-evaluations mt-4">
                    {factors.map(f => {
                        const summary = summaryAnswer.factors.find(ans => ans.key === f.factor_id);
                        const textData = summary?.data || {};

                        return (
                            <div key={f.factor_id} >
                                <div className="mb-3 label-semibold text-uppercase factor-title">{f.factor}</div>
                                {f.text_evaluations.map(({ label, max_chars }) => {
                                    const keyLabel = label.toLowerCase().replace(/\s/g, '_');
                                    return (
                                        <div className="textarea-wrapper mb-3" key={`${f.factor_id}-${keyLabel}`}>
                                            <label className='label-semibold mb-3'>{label}</label>
                                            <div className="text-evaluation">{textData[keyLabel] || ""}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div >
    );
};

export default EvaluationReview;
